import * as _ from 'lodash';
import getTranslationOrEnglish from 'client/utils/i18n/i18nUtils';
import { LOCALES as LOCALE } from 'i18n/locales';

export const filterActivityTypes = (activityTypes, locale) => {
    const activitiesWithCategory = activityTypes.filter(
        activity => Object.prototype.hasOwnProperty.call(activity.category, locale) || Object.prototype.hasOwnProperty.call(activity.category, LOCALE.ENGLISH));
    activitiesWithCategory.forEach(activity => {
        activity.translatedCategory = getTranslationOrEnglish(activity.category, locale);
    });
    const groupedActivities = _.groupBy(activitiesWithCategory, 'translatedCategory');
    return groupedActivities;
};
